<template>
	<div>
		<el-row type="flex" align="middle" justify="space-between" style="height: 100%;padding: 20px 80px;"
			:style="isHome?'':'box-shadow: 5px -5px 5px 5px #354e6b;'">
			<el-row type="flex" align="bottom" justify="start" :style="isHome?'color: white;':'color: #45465e;'">
				<el-link :style="isHome?'color: white;':'color: #45465e;'" @click="$router.replace({ name: 'home' })"
					style="font-size: 26px;">
					AI高分面试训练营
				</el-link>
				<div :style="isHome?'color: white;':'color: #45465e;'" style="margin-left: 20px;font-weight: 500;">
					Offer拿到手软
				</div>
			</el-row>
			<el-row type="flex" align="middle" justify="end" :style="isHome?'color: white;':'color: #45465e;'">
				<el-link @click="$router.push({ name: 'about' })" :style="isHome?'color: white;':'color: #45465e;'"
					style="margin-right: 15px;">
					关于我们
				</el-link>
				<el-link @click="$router.push({ name: 'read' })" :style="isHome?'color: white;':'color: #45465e;'"
					style="margin-right: 15px;">
					面试必读
				</el-link>
				<el-link @click="dialogVisible = true" :style="isHome?'color: white;':'color: #45465e;'"
					style="margin-right: 15px;">
					留言建议
				</el-link>
				<el-link v-if="userinfo" @click="$router.push({ name: 'buy' })"
					:style="isHome?'color: white;':'color: #45465e;'" style="margin-right: 15px;">
					购买算力
				</el-link>
				<el-row v-if="userinfo" type="flex" align="middle" justify="center"
					style="color: white;margin-right: 15px;background-color: #354e6b;width: 40px;height: 40px;border-radius: 20px;">
					{{userinfo?userinfo["username"][0]:""}}
				</el-row>
				<el-dropdown>
					<el-link @click="userinfo?'':$router.replace({ name: 'login' })" class="el-dropdown-link"
						:style="isHome?'color: white;':'color: #45465e;'">
						{{userinfo?userinfo["username"]:"免费注册"}}
					</el-link>
					<el-dropdown-menu v-if="userinfo" slot="dropdown">
						<el-dropdown-item @click.native="$router.push({ name: 'personal' })">个人中心</el-dropdown-item>
						<el-dropdown-item @click.native="quit()">退出登录</el-dropdown-item>
						<el-dropdown-item @click.native="close()">注销账号</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-row>
		</el-row>

		<el-dialog title="留言建议" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
			<el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="textarea">
			</el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'TopBar',
		props: {
			isHome: {
				type: Boolean,
				defined: false,
			},
			info: {
				type: Object,
				defined: {},
			}
		},
		data() {
			return {
				dialogVisible: false,
				textarea: "",
				userinfo: ""
			}
		},
		watch: {
			info() {
				const userinfo = localStorage.getItem("userinfo")
				if (userinfo) {
					this.userinfo = JSON.parse(userinfo)
				}
			}
		},
		created() {
			const userinfo = localStorage.getItem("userinfo")
			if (userinfo) {
				this.userinfo = JSON.parse(userinfo)
			}
		},
		methods: {
			submit() {
				if (!this.textarea) {
					this.dialogVisible = false
					return;
				}
				this.http.post("/config/send", {
					content: this.textarea
				}).then(response => {
					if (response.data.status == 0) {
						this.$message({
							message: '留言成功',
							type: 'success'
						});
					}
				})
				this.dialogVisible = false
			},
			close() {
				this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.http.get("/api/closeUser").then(response => {
						if (response.data.status == 0) {
							localStorage.removeItem("token");
							localStorage.removeItem("userinfo")
							this.userinfo = ""
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.$router.replace({
								name: 'home'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			quit() {
				localStorage.removeItem("token");
				localStorage.removeItem("userinfo")
				this.userinfo = ""
				this.$router.replace({
					name: 'home'
				});
			},
		}
	}
</script>

<style>
</style>